import { getMediaDevices } from '@gem/call/Removable/packages/deviceInfo/deviceInfo';
import { media } from '@gem/call/Removable/packages/permissions/permissions';
import { t } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';

export const hasCameraPermission = async (deviceId?: string): Promise<boolean> => {
  const { hasCamera } = await getMediaDevices();

  if (!hasCamera) {
    popupsTasks.showAlert(t('calls_no_camera_connected'));

    return false;
  }

  const hasVideoPermission = await media.getVideoPermission(deviceId);

  if (!hasVideoPermission) {
    popupsTasks.showAlert(t('calls_no_camera_permissions_web'));
    return false;
  }

  return true;
};
